import { PointerLockControls } from "@controllers/controls";
import { overlay, paused, setOverlay } from "@stores";
import { KeyBindings } from "./consts";
class UIInputController {
    pointerLockControls;
    static instance;
    /**
     * UIInputController handles keyboard events that control the UI.
     * @param cameraManger The game's camera manager.
     * @param rendererManger The game's renderer.
     * @private
     */
    constructor(cameraManger, rendererManager) {
        this.pointerLockControls = PointerLockControls.getInstance();
        this.listen(cameraManger, rendererManager);
    }
    /**
     * Listen to keyboard input.
     * @param cameraManger The game's camera manager.
     * @param rendererManger The game's renderer.
     */
    listen(cameraManager, rendererManager) {
        this.handleLockMouse();
        window.addEventListener("resize", () => {
            cameraManager.updateResolution();
            rendererManager.updateResolution();
        });
        window.addEventListener("keypress", event => {
            if (event.code === KeyBindings.SWITCH_CAMERA)
                cameraManager.switch();
            if (event.code === KeyBindings.TOGGLE_DEBUG_OVERLAY)
                setOverlay(!overlay());
        });
    }
    /**
     * Lock the mouse for pointer-lock controls.
     */
    handleLockMouse() {
        window.addEventListener("click", () => {
            if (paused() || this.pointerLockControls.getIsLocked)
                return;
            this.pointerLockControls.lock();
        });
    }
    static getInstance(cameraManager, rendererManager) {
        if (!UIInputController.instance)
            UIInputController.instance = new UIInputController(cameraManager, rendererManager);
        return UIInputController.instance;
    }
}
export { UIInputController };
